var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
import * as React from 'react'
import styled from 'styled-components'
var FooterWrapper = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ['\n  display: flex;\n  flex-direction: row;\n'],
      ['\n  display: flex;\n  flex-direction: row;\n']
    ))
)
export var ODModalFooter = function (_a) {
  var children = _a.children
  return React.createElement(FooterWrapper, null, children)
}
var templateObject_1
//# sourceMappingURL=ODModalFooter.js.map
